/** @jsx jsx */
import { memo } from "react";
import { jsx, Styled } from "theme-ui";

const Lead: React.FC<{ children: string }> = ({ children }) => {
  return (
    <div
      sx={{
        borderBottomColor: "muted",
        borderBottomStyle: "solid",
        borderBottomWidth: [0, 2],
        color: "accent",
        fontSize: [2, 3],
        marginBottom: 4,
        paddingBottom: [0, 4],
        mixBlendMode: "multiply",
      }}
    >
      <div
        sx={{
          ml: [0, 0, 0, 8],
          marginRight: [0, 0, 0, 8],
          position: "relative",
        }}
      >
        <span
          sx={{
            color: "muted",
            display: ["none", "block"],
            fontFamily: "heading",
            fontSize: ["10rem", "10rem", "10rem", "15.625rem"],
            left: ["-3.5rem", "-3.5rem", "-3.5rem", "-4.5rem"],
            lineHeight: 1,
            mixBlendMode: "multiply",
            position: "absolute",
            top: ["-1.5rem", "-1.5rem", "-1.5rem", "-2.5rem"],
          }}
        >
          {"“"}
        </span>
        <Styled.b sx={{ display: "block", position: "relative" }}>
          {children}
        </Styled.b>
      </div>
    </div>
  );
};

export default memo(Lead);
